const Spinner = ({ className }) => {
  return (
    <div className={`${className} spinner`}></div>
  );
}

export default Spinner;
